import { Component, OnInit, Input } from '@angular/core';
import { SimplifiedTarget } from '@schoolbelle/api/letter-target';

@Component({
  selector: 'app-letter-simplified-target-text',
  templateUrl: './letter-simplified-target-text.component.html',
  styleUrls: ['./letter-simplified-target-text.component.scss']
})
export class LetterSimplifiedTargetTextComponent implements OnInit {
  @Input() targets:SimplifiedTarget[] = [];
  constructor() { }

  ngOnInit() {
  }
  isCheckedAll (target:SimplifiedTarget):boolean {
    return target && target.scopes && target.scopes.match(/studentparent_(?!all)|faculty_(?!all)/)? false : true;
  }
  getScopePrefix (scopes:string) {
    const match = scopes && scopes.match(/studentparent|faculty|admin/);
    return match && match[0];

  }

}
